import { transformToValidFromAndValidTo } from '../../../common/utils/schema/transformers/transformValidPeriod';
import {
  CategoryRelationValidFormDataSchema,
  CategoryValidFormDataSchema,
} from '../validFormData/CategoryValidFormDataSchema';
import { z } from 'zod/v3';

export const CategoryRelationMutationDtoSchema = transformToValidFromAndValidTo(
  CategoryRelationValidFormDataSchema,
).transform(({ subCategory, ...rest }) => ({
  ...rest,
  subCategoryCode: subCategory,
}));

export const CategoryMutationDtoSchema = transformToValidFromAndValidTo(
  CategoryValidFormDataSchema.omit({ categoryRelations: true }).extend({
    categoryRelations: z.array(CategoryRelationMutationDtoSchema),
  }),
);
